import { CalendarSharingStore } from './schema/CalendarSharingStore';
import '../mutators/addCalendarSharingPermissionMutator';
import '../mutators/hideCalendarSharingPermissionsDialogMutator';
import '../mutators/removeCalendarInvitePermissionMutator';
import '../mutators/removeCalendarSharingPermissionMutator';
import '../mutators/saveCalendarSharingPermissionForSelectedPersonMutator';
import '../mutators/saveInitialCalendarSharingPermissionsMutator';
import '../mutators/setCalendarSharingErrorMutator';
import '../mutators/setCalendarSharingInitialLoadMutator';
import '../mutators/setDeliveryOptionUpdatePendingMutator';
import '../mutators/setInitialSharingPermissionsPendingMutator';
import '../mutators/setPeoplePickerPermissionPendingMutator';
import '../mutators/setSendInvitePendingMutator';
import '../mutators/setSharingPermissionErrorMutator';
import '../mutators/setSharingPermissionPendingMutator';
import '../mutators/showCalendarSharingPermissionsDialogMutator';
import '../mutators/updateCalendarSharingPermissionMutator';
import '../mutators/updateCurrentDeliveryOptionMutator';
import '../mutators/updateSelectedRecipientInviteMutator';
import { createStore } from 'satcheljs';

let initialCalendarSharingStoreData: CalendarSharingStore = {
    viewState: null,
};

export default createStore<CalendarSharingStore>(
    'CalendarSharingStore',
    initialCalendarSharingStoreData
);
